import styled from 'styled-components';

export const Container = styled.div`
  * {
    font-family: 'Noto Sans KR', sans-serif;
    font-weight: 300;
  }
  /* z-index: 9999; */
  position: fixed;
  top: 0;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: center;
  align-items: flex-end;
`;

export const FormContainerWrapper = styled.div`
  width: 100%;
  height: 80%;
  background: #ffffff;
  border-top-right-radius: 20px;
  border-top-left-radius: 20px;
`;

export const FormContainer = styled.div`
  height: 100%;
  padding: 0 10%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const InfoIcon = styled.span`
  font-size: 3rem;
  margin-top: -1.5rem;
  margin-bottom: 0.5rem;
`;
export const InfoDescription = styled.div`
  font-size: 1.5rem;
  font-weight: 300;
  color: #121c26;
  text-align: center;
`;

export const QueryInput = styled.input`
  margin-top: 0.5rem;
  font-size: 14px;
  color: rgb(230, 158, 33);
  font-weight: 600;
  min-height: 40px;
  padding-left: 10px;
  border: 1px solid rgb(230, 158, 33);
  border-radius: 10px;
  text-align: center;
  &::placeholder {
    color: rgb(230, 158, 33);
    font-weight: 600;
  }
  &:focus {
    outline: none;
  }
`;
export const GetNowPosition = styled.button`
  margin-top: 1rem;
  padding: 5px 0;
  border-radius: 10px;
  font-weight: 600;
  font-size: 14px;
  color: white;
  background: rgb(230, 158, 33);
  border: 0;
`;

export const QueryResult = styled.div`
  font-size: 1rem;
  margin: 0.5rem 0;
  padding: 0 0.5rem;
  &:hover {
    cursor: pointer;
    color: rgb(230, 158, 33);
    font-weight: 500;
  }
`;

export const InfoMessage = styled.div`
  font-size: 14px;
  text-align: center;
  margin: 15px 0;
`;
